import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Pipe({
    name: 'colorSvg',
    pure: false
})
export class ColorSvgPipeSolar implements PipeTransform {
    constructor(private sanitized: DomSanitizer) { }

    transform(value: string, color: any): SafeHtml {
        let r = value.split('path');
        return this.sanitized.bypassSecurityTrustHtml(r[0] + "path style='fill:" + color + "'" + r[1]);
    }
}

@Component({
    selector: 'itpx-type-tile-solar',
    templateUrl: './type-tile.component.html',
    styleUrls: ['./type-tile.component.css']
})
export class TypeTileSolarComponent implements OnInit {

    @Input() data: any;
    @Output() onSave = new EventEmitter<any>();

    constructor() { }

    ngOnInit() { }

    private onClick() {
        if (this.data.isDisabled) {
            return null
        } else {
            this.onSave.emit(this.data)
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/solar/common/type-tile-solar/type-tile.component.ts